import { useQuery } from "@tanstack/react-query";
import type { DashboardQuery } from "@/app/api/types";
import { dashboardService } from "../services/dashboard.service";

export const dashboardKeys = {
	all: ["dashboard"] as const,
	stats: (params: DashboardQuery) => [...dashboardKeys.all, "stats", params] as const,
	brigadeRatings: (organizationId: string) =>
		[...dashboardKeys.all, "brigade-ratings", organizationId] as const,
};

export function useDashboardStats(params: DashboardQuery) {
	return useQuery({
		queryKey: dashboardKeys.stats(params),
		queryFn: () => dashboardService.getStats(params),
		enabled: !!params.organizationId,
	});
}

export function useBrigadeRatings(organizationId: string) {
	return useQuery({
		queryKey: dashboardKeys.brigadeRatings(organizationId),
		queryFn: () => dashboardService.getBrigadeRatings(organizationId),
		enabled: !!organizationId,
	});
}
